import type { TaskArgument } from "@/types/challenges.types";

type DeviceInfo = Pick<Navigator, "userAgent" | "platform" | "maxTouchPoints">;

export function resolveClickLink(
  args: TaskArgument[] | Record<string, string>,
  device: DeviceInfo | undefined = typeof navigator === "undefined" ? undefined : navigator,
): string | undefined {
  const get = (name: string) =>
    (Array.isArray(args) ? args.find((arg) => arg.name === name)?.value : args[name]) || undefined;

  const link = get("link");
  const androidLink = get("androidLink");
  const iosLink = get("iosLink");
  const ua = device?.userAgent || "";
  const isIOS = /iPad|iPhone|iPod/.test(ua) ||
    (device?.platform === "MacIntel" && device.maxTouchPoints > 1);

  if (isIOS) return iosLink ?? link ?? androidLink;
  if (/Android/i.test(ua)) return androidLink ?? link ?? iosLink;
  return link ?? androidLink ?? iosLink;
}
